module.exports = __webpack_public_path__ + "img/deletehover.cba01199.svg";